import { render, staticRenderFns } from "./recently-viewed.vue?vue&type=template&id=250db038&"
import script from "./recently-viewed.vue?vue&type=script&lang=js&"
export * from "./recently-viewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports